import {Button, Flex, FormLabel, Input} from '@chakra-ui/react'
import {useState} from "react";

export const SeqNumModal = ({ onApply }) => {
    const [seqRead, setSeqRead] = useState('')
    const [seqWrite, setSeqWrite] = useState('')

    return (
        <div>
            <FormLabel marginTop={4}>SeqRead number</FormLabel>
            <Flex>
                <Input mb={4} value={seqRead} onChange={e => setSeqRead(e.target.value)} />
                <Button ml={4} onClick={() => onApply('read', seqRead)}>
                    Set
                </Button>
            </Flex>
            <FormLabel>SeqWrite number</FormLabel>
            <Flex>
                <Input mb={4} value={seqWrite} onChange={e => setSeqWrite(e.target.value)} />
                <Button ml={4} onClick={() => onApply('write', seqWrite)}>
                    Set
                </Button>
            </Flex>
        </div>
    )
}
